





























import Vue from 'vue';
import Icon from '../Icon';

export default Vue.extend({
  components: { Icon },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
});
